// An arrival at the poster collection from a year's page, /<year>/Posters → /Posters/<year>
// (the router's redirect): the gallery then offers a way back to the year (Seán, 2026-11-01).
// Noted by the redirect, read by the gallery, cleared once the person moves on (the address
// changes: a filter, a poster, another page). Nothing in the address: a reload shows no arrow.
import {ref} from "vue";

const arrivedFromYear = ref("");

export const noteYearArrival = (year) => (arrivedFromYear.value = year || "");
export const clearYearArrival = () => (arrivedFromYear.value = "");
export default () => arrivedFromYear;
